module.exports = __webpack_public_path__ + "static/img/duijiang2.00ee04d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/duijiang2.png
// module id = /CRJ
// module chunks = 24